import script from "./DynamicScrollerItem.vue?vue&type=script&lang=js"
export * from "./DynamicScrollerItem.vue?vue&type=script&lang=js"

export default script